import React from 'react'
import { SnopConfigPage } from '@auteco/pages'

const SnopConfigContainer = () => {
    return (
        <SnopConfigPage />
    )
}

export { SnopConfigContainer }